import { LOCATION_CONTEXT_MENU_SERVICE_NAME, LocationContextMenuServiceProvider } from './location.context-menu.service'
import { LOCATION_EQUIPMENT_SERVICE_NAME, LocationEquipmentServiceProvider } from './location.equipment.service'
import { LOCATION_RELATED_OBJECT_SERVICE_NAME, LocationRelatedObjectServiceProvider } from './location.related-object.service'
import { LOCATION_SERVICE_NAME, LocationServiceProvider } from './location.service'

export const LOCATION_SERVICES_MODULE_NAME = 'simax.services.location'

const locationServicesModule = angular.module(LOCATION_SERVICES_MODULE_NAME, [])

locationServicesModule.provider(LOCATION_CONTEXT_MENU_SERVICE_NAME, LocationContextMenuServiceProvider)
locationServicesModule.provider(LOCATION_EQUIPMENT_SERVICE_NAME, LocationEquipmentServiceProvider)
locationServicesModule.provider(LOCATION_RELATED_OBJECT_SERVICE_NAME, LocationRelatedObjectServiceProvider)
locationServicesModule.provider(LOCATION_SERVICE_NAME, LocationServiceProvider)
